export abstract class ClickRowService {
    abstract clickRow(row, index, props?): void;
    abstract init?(): void;
    abstract destroy?(): void;
}

export class DefaultClickRowService {
    public clickRow() { }
}

export const defaultClickRowServiceProvider = {
    provide: ClickRowService,
    useClass: DefaultClickRowService,
};
